import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  
  constructor() { }

  getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    const userAgent = navigator.userAgent.toLowerCase();
    
    if (/mobile/i.test(userAgent)) {
      return 'mobile';
    }
    if (/tablet/i.test(userAgent)) {
      return 'tablet';
    }
    return 'desktop';
  }

  getDeviceSize(): 'mobile' | 'tablet' | 'desktop' {
    const width = window.innerWidth;

    if (width <= 599) {
      return 'mobile';
    }
    if (width >= 600 && width <= 1199) {
      return 'tablet';
    }
    return 'desktop';
  }
}